import { createContext, useContext } from 'react';
import type { RoadmapResource } from '@mrrmlab/api-client';

const RoadmapApiContext = createContext<RoadmapResource | null>(null);

export const RoadmapApiProvider = RoadmapApiContext.Provider;

export function useRoadmapApi(): RoadmapResource {
  const ctx = useContext(RoadmapApiContext);
  if (!ctx) throw new Error('useRoadmapApi called outside <RoadmapApiProvider>');
  return ctx;
}
